<template>
  <div class="dialog">
    <!-- 添加跟进记录 -->
    <el-dialog
      :title="`${lookbtn ? '查看' : '添加'}跟进计划`"
      :visible.sync="followUp"
      width="50%"
      @close="resumeclickClose"
      :modal-append-to-body="false"
    >
      <div v-if="showStudentInfo && studentInfo">
        <div class="student">学员信息:</div>
        <div class="student-info">
          <p>{{ studentInfo.name }} | {{ studentInfo.mobile }}</p>
          <p>
            {{ studentInfo.age }} |
            {{
              studentInfo.student_source ? studentInfo.student_source.name : "-"
            }}
          </p>
        </div>
        <div class="student" style="padding-top: 20px">跟进信息:</div>
      </div>
      <el-form
        size="mini"
        ref="form"
        :model="searchInfo"
        inline
        label-width="65px"
        class="dialogForm"
        :rules="rules"
      >
        <el-form-item label="跟进方式：" label-width="85px" prop="mode">
          <el-select
            placeholder="请选择"
            class="drawer_onlychoose"
            v-model.number="searchInfo.mode"
            :disabled="lookbtn"
          >
            <el-option
              v-for="item in followupMethods"
              :key="item.value"
              :label="item.value"
              :value="Number(item.key)"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用户意向：" label-width="85px" prop="intent">
          <el-select
            placeholder="请选择"
            class="drawer_onlychoose"
            v-model.number="searchInfo.intent"
            :disabled="lookbtn"
          >
            <el-option
              v-for="item in followupintent"
              :key="item.value"
              :label="item.value"
              :value="Number(item.key)"
            ></el-option>
          </el-select>
          <div class="selfheader">
            <el-popover
              placement="top"
              width="190"
              popper-class="followuppopover"
              trigger="hover"
            >
              <p class="tipck">
                A - 高意向，B - 中意向，C - 低意向，D - 无意向；
              </p>
              <div class="question" slot="reference">
                <div>?</div>
              </div>
            </el-popover>
          </div>
        </el-form-item>
        <el-form-item label="跟进阶段：" label-width="85px" prop="stage">
          <el-select
            placeholder="请选择"
            class="drawer_onlychoose"
            v-model.number="searchInfo.stage"
            :disabled="lookbtn"
          >
            <el-option
              v-for="item in followupstage"
              :key="item.value"
              :label="item.value"
              :value="Number(item.key)"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="imageText" :class="lookbtn ? 'black' : ''">
        <div class="order-text" v-if="searchInfo.stage === 6">
          {{ searchInfo.order_text }} “
          <span
            class="mwow-green"
            style="cursor: pointer"
            @click="toOrderDetail(searchInfo.relation_id)"
          >
            {{ searchInfo.order_no }}
          </span>
          ”。
        </div>
        <el-input
          class="textarea"
          type="textarea"
          :rows="3"
          :placeholder="lookbtn ? '' : '请输入内容'"
          v-model="fwtextarea"
          :disabled="lookbtn"
          resize="none"
          v-else
        >
        </el-input>
        <!-- <textarea
          placeholder="请输入跟进内容"
          v-model="fwtextarea"
          :disabled="lookbtn"
        ></textarea> -->
        <div v-if="lookbtn == false">
          <OSSImageUploader
            :preview="true"
            @set-img-url="setCoverS"
            @del-img="delImg"
            :oriImage="dialogImageUrl"
            :clearMark="followUp"
            :size="[44, 44]"
            :types="'list'"
          ></OSSImageUploader>
        </div>
        <div v-else>
          <div class="followupImg" v-if="images_url.length > 0">
            <div
              class="imgbox"
              v-for="(items, index) in images_url"
              :key="index"
            >
              <span class="imgboxbig" @click="handlePictureCardPreview(items)">
                <i class="el-icon-zoom-in"></i>
              </span>
              <img :src="items" alt="" />
            </div>
          </div>
        </div>
      </div>
      <div class="next_follow" v-if="lookbtn == false">
        <div class="next_follow_left">
          下次跟进时间：
          <el-date-picker
            type="datetime"
            placeholder="请选择"
            value-format="timestamp"
            v-model="dateTimes"
            @change="changedateTimes"
            :picker-options="expireTimeOption"
          >
          </el-date-picker>
        </div>
        <div class="next_follow_right">
          <span>最多上传9张图片，每张大小5M以内，格式为png、jpeg、jpg</span>
        </div>
      </div>
      <div class="imageText" v-if="dateTimesBtn">
        <textarea placeholder="请输入" v-model="netextarea"></textarea>
      </div>
      <span slot="footer" class="dialog-footer">
        <div @click="resumeclickClose" class="mwow-button-filled mini btnsize">
          取 消
        </div>
        <div
          @click="getfollowadd"
          v-if="lookbtn == false"
          class="mwow-button-filled mini success btnsize"
        >
          确 定
        </div>
      </span>
    </el-dialog>
    <!-- 添加跟进记录结束 -->
    <!-- 停课 -->
    <el-dialog
      title="停课"
      :visible.sync="suspensionBtn"
      @close="resumeclickClose"
      width="30%"
      :modal-append-to-body="false"
    >
      <div class="explain">
        停课后，学员【{{
          ClassName
        }}】将不能点名签到，同时不会再收到开课提醒、班级课时作业；
        课程的有效期将被取消；
        <br />
        如果设置了复课日期，到期后将自动恢复上课，可以进行点名签到，开课提醒、班级课时作业提醒都可以收到。
      </div>
      <el-form
        size="mini"
        :inline="true"
        :model="suspensionformIn"
        :rules="stoprules"
        ref="suspension"
      >
        <div class="suspensionBox">
          <el-form-item
            label="停课时间:"
            label-width="80px"
            prop="start_time_suspen"
          >
            <el-date-picker
              v-model="suspensionformIn.start_time_suspen"
              type="date"
              placeholder="请选择时间"
              value-format="timestamp"
              :picker-options="expireTimeOption"
            >
            </el-date-picker>
          </el-form-item>
        </div>
        <div class="suspensionBox">
          <el-form-item label="复课时间:" label-width="80px">
            <el-date-picker
              v-model="suspensionformIn.end_time_suspen"
              type="date"
              placeholder="请选择时间"
              value-format="timestamp"
              :picker-options="expireTimeOption"
            >
            </el-date-picker>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <div class="mwow-button-filled mini" @click="resumeclickClose">
          取 消
        </div>
        <div
          class="mwow-button-filled mini success"
          @click="suspensionclickComfir"
        >
          停 课
        </div>
      </span>
    </el-dialog>
    <!-- 停课end -->
    <!-- 复课 -->
    <el-dialog
      title="复课"
      :visible.sync="resumeBtn"
      width="30%"
      @close="resumeclickClose"
      :modal-append-to-body="false"
    >
      <div class="explain color">复课后，请重新设置课程最终到期时间</div>
      <el-form
        size="mini"
        :inline="true"
        :model="resumeformIn"
        :rules="stoprules"
        ref="suspension"
      >
        <div class="suspensionBox">
          <el-form-item label="停课时间:" label-width="80px">
            <el-input v-model="resumeformIn.start_time_suspen" :disabled="true">
            </el-input>
          </el-form-item>
        </div>
        <div class="suspensionBox">
          <el-form-item
            label="复课时间:"
            label-width="80px"
            prop="end_time_suspen"
          >
            <el-date-picker
              v-model="resumeformIn.end_time_suspen"
              type="date"
              placeholder="请选择时间"
              value-format="timestamp"
              :picker-options="expireTimeOption"
            >
            </el-date-picker>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <div class="mwow-button info" @click="resumeclickClose">取 消</div>
        <div class="mwow-button-filled success" @click="resumeclickComfir">
          复 课
        </div>
      </span>
    </el-dialog>
    <!-- 复课end -->
    <!-- 修改跟进计划 -->
    <el-dialog
      title="编辑跟进计划"
      :visible.sync="editfollUp"
      width="50%"
      @close="resumeclickClose"
      :modal-append-to-body="false"
    >
      <el-form size="mini" ref="editform" :model="editform" label-width="80px">
        <div class="next_follow_edit">
          <div>
            下次跟进时间：
            <el-date-picker
              type="datetime"
              placeholder="选择日期时间"
              value-format="timestamp"
              v-model="editform.pre_follow_time"
              :picker-options="notodayTime"
            >
            </el-date-picker>
          </div>
        </div>
        <div class="imageText">
          <textarea placeholder="请输入" v-model="editform.content"></textarea>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <div @click="resumeclickClose" class="mwow-button-filled mini btnsize">
          取 消
        </div>
        <div
          @click="getfollowadd"
          class="mwow-button-filled mini success btnsize"
        >
          确 定
        </div>
      </span>
    </el-dialog>
    <!-- 修改跟进计划end -->
    <!-- 取消跟进计划 -->
    <el-dialog
      title="取消跟进计划"
      :visible.sync="closefollUp"
      width="50%"
      @close="resumeclickClose"
      :modal-append-to-body="false"
    >
      <el-form
        size="mini"
        ref="closeform"
        :model="closeform"
        label-width="80px"
        class="cancel-form"
      >
        <el-form-item label="取消原因：" label-width="75px">
          <div class="imageText">
            <textarea
              placeholder="请输入"
              v-model="closeform.cancel_remark"
            ></textarea>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <div @click="resumeclickClose" class="mwow-button-filled mini btnsize">
          取 消
        </div>
        <div
          @click="getfollowadd"
          class="mwow-button-filled mini success btnsize"
        >
          确 定
        </div>
      </span>
    </el-dialog>
    <!-- 取消跟进计划end -->
    <el-dialog :visible.sync="bigdialogVisible" :modal-append-to-body="false">
      <img width="100%" :src="bigdialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>
<script>
import {
  getcourseFreeze,
  getcourseUnfreeze,
  getfreezerecord,
  getfollowmode,
  getfollowintent,
  getfollowadd,
  getfollowedit,
  getfollowclose,
} from "@/api/studyDetails";
import { getFollowStageApi } from "@/api/studentFollow";
import OSSImageUploader from "@/components/ossImageUploader.vue";

export default {
  name: "detailsDialog",
  components: {
    OSSImageUploader,
  },
  // @Prop() type!: any;
  // @Prop() itemdata!: any;
  // @Prop() showStudentInfo?: boolean;
  // @Prop() studentInfo?: any;
  props: ["type", "itemdata", "showStudentInfo", "studentInfo"],
  data() {
    return {
      closefollUp: false, //取消
      editfollUp: false, //跟进
      followUp: false, //跟进弹框开关
      suspensionBtn: false, //复课弹框开关
      resumeBtn: false, //停课弹框开关
      followupMethods: [],
      followupstage: [],
      followupintent: [],
      dialogImageUrl: [],
      dialogImageUrlName: [],
      disabled: false,
      searchInfo: {}, //跟进表单
      suspensionformIn: {}, //停课表单
      resumeformIn: {
        start_time_suspen: "",
      }, //复课表单
      stop_id: 0,
      rules: {
        mode: [{ required: true, message: "请选择跟进方式", trigger: "blur" }],
        stage: [{ required: true, message: "请选择跟进阶段", trigger: "blur" }],
        intent: [
          { required: true, message: "请选择用户意向", trigger: "blur" },
        ],
      },
      stoprules: {
        start_time_suspen: [{ required: true, message: "请选择时间" }],
        end_time_suspen: [{ required: true, message: "请选择时间" }],
      },
      fwtextarea: "", //记录文本域
      dateTimes: "", //下次记录日期
      dateTimesBtn: false, //下次记录文本域开关
      netextarea: "", //下次跟进文本域
      editform: {
        pre_follow_time: "",
      },
      id: "",
      student_id: "",
      ClassName: "",
      closeform: {},
      dialogForm: {},
      lookbtn: false,
      images_url: [],
      bigdialogVisible: false,
      bigdialogImageUrl: "",
      pickerOptions: {
        //今天之前的
        disabledDate(time) {
          return time.getTime() > Date.now() - 24 * 3600 * 1000;
        },
      },
      expireTimeOption: {
        //今天之后的包括今天
        disabledDate: (time) => {
          return time.getTime() < Date.now() - 1 * 24 * 3600 * 1000;
        },
      },
      notodayTime: {
        //今天之后的不包括今天
        disabledDate: (time) => {
          return time.getTime() < Date.now();
        },
      },
    };
  },

  created() {
    const _t = this;
    switch (_t.type) {
      //如果是这个type是跟进计划的 data是一堆数据，其他的data是一个id
      case "close":
        _t.closefollUp = true;
        _t.id = _t.itemdata.id;
        break;
      case "edit":
        _t.editfollUp = true;
        _t.id = _t.itemdata.id; //跟进id
        _t.student_id = _t.itemdata.student_id;
        //编辑数据初始化
        const time = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
        _t.editform.pre_follow_time = _t.itemdata.pre_follow_time
          ? Number(_t.itemdata.pre_follow_time + "000")
          : Date.parse(time).toString(); //跟进日期

        break;
      case "look":
        //编辑数据初始化
        //_t.fwtextarea = _t.itemdata.content; //跟进富文本
        //编辑数据初始化结束
        _t.lookbtn = true;
        const pordData = { ..._t.itemdata };
        _t.searchInfo.stage =
          pordData.stage || pordData.follow_stage.follow_stage_id;
        _t.searchInfo.intent = pordData.intent;
        _t.searchInfo.mode = pordData.mode;
        if (pordData.stage === 6) {
          _t.searchInfo.relation_id = pordData.relation_id;
          let no = /\d+/.exec(pordData.content);
          _t.searchInfo.order_no = no[0];
          _t.searchInfo.order_text = pordData.content.slice(0, no.index - 1);
        }
        _t.fwtextarea = pordData.content;
        if (pordData.images_url) {
          _t.images_url = pordData.images_url;
        }
        _t.getfollowstageData();
        _t.getfollowmodeData();
        _t.getfollowintentData();
        _t.followUp = true;
        break;
      case "followUp":
        _t.id = _t.itemdata.id;
        _t.student_id = _t.itemdata.student_id;
        //编辑数据初始化
        _t.fwtextarea = _t.itemdata.content; //跟进富文本
        //编辑数据初始化结束
        _t.getfollowmodeData();
        _t.getfollowstageData();
        _t.getfollowintentData();
        _t.followUp = true;
        break;
      case "add":
        _t.student_id = _t.itemdata;
        _t.getfollowmodeData();
        _t.getfollowstageData();
        _t.getfollowintentData();
        _t.followUp = true;
        break;
      case "stop":
        _t.id = _t.itemdata.account_id;
        _t.ClassName = _t.itemdata.course.title;
        _t.suspensionBtn = true;
        break;
      case "resume":
        _t.id = _t.itemdata.account_id;
        _t.resumeBtn = true;
        _t.getstopId(_t.id);
        break;
    }
  },
  methods: {
    setCoverS(res) {
      const _t = this;
      _t.dialogImageUrl.push(res.data.object);
      _t.dialogImageUrlName.push(res.name);
    },
    delImg(res) {
      const _t = this;
      _t.dialogImageUrl.splice(res, 1);
    },
    dateYearMonthDay(unixtime) {
      const dateTime = new Date(unixtime);
      const year = dateTime.getFullYear();
      let month = dateTime.getMonth() + 1;
      if (month > 0 && month < 10) {
        month = "0" + month;
      }
      let day = dateTime.getDate();
      if (day > 0 && day < 10) {
        day = "0" + day;
      }
      const timeSpanStr = year + "-" + month + "-" + day;
      return timeSpanStr;
    },
    getfollowmodeData() {
      const _t = this;
      getfollowmode().then((res) => {
        if (res.error_code == 0) {
          // 去掉无
          // res.data.list.push({
          //   key: 0,
          //   value: "无",
          // });
          _t.followupMethods = res.data.list;
        }
      });
    },
    getfollowstageData() {
      const _t = this;
      getFollowStageApi({
        student_id: Number(_t.student_id),
      }).then((res) => {
        if (res.error_code == 0) {
          _t.followupstage = res.data.list;
        }
      });
    },
    getfollowintentData() {
      const _t = this;
      getfollowintent().then((res) => {
        if (res.error_code == 0) {
          _t.followupintent = res.data.list;
        }
      });
    },
    resumeclickClose(type) {
      this.followUp = false;
      this.suspensionBtn = false;
      this.resumeBtn = false;
      if (type) {
        this.$emit("back", type);
      } else {
        this.$emit("back");
      }
    },
    getstopId(account_id) {
      const _t = this;
      getfreezerecord({ account_id: account_id }).then((res) => {
        if (res.error_code == 0) {
          res.data.list.map((a) => {
            if (a.status != 3) {
              _t.stop_id = a.stop_id;
              _t.resumeformIn.start_time_suspen = _t.dateYearMonthDay(
                a.start_time * 1000
              );
            }
          });
        }
      });
    },
    suspensionclickComfir() {
      const _t = this;
      const data = {};
      data.account_id = _t.id;
      if (
        !_t.suspensionformIn.start_time_suspen ||
        _t.suspensionformIn.start_time_suspen == ""
      ) {
        _t.$message({
          type: "error",
          message: "请选择停课时间",
        });
        return;
      }
      if (_t.suspensionformIn.start_time_suspen) {
        data.start_time = _t.suspensionformIn.start_time_suspen / 1000;
      }
      if (_t.suspensionformIn.end_time_suspen) {
        data.end_time = _t.suspensionformIn.end_time_suspen / 1000;
      }
      _t.$refs["suspension"].validate((valid) => {
        if (valid) {
          getcourseFreeze(data).then((res) => {
            if (res.error_code == 0) {
              _t.$message({
                type: "success",
                message: "停课成功!",
              });
              _t.resumeclickClose(_t.type);
            } else {
              _t.$message({
                type: "error",
                message: "停课失败!" + res.message,
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    resumeclickComfir() {
      const _t = this;
      const data = {};
      data.stop_id = _t.stop_id;
      if (
        !_t.resumeformIn.end_time_suspen ||
        _t.resumeformIn.end_time_suspen == ""
      ) {
        _t.$message({
          type: "error",
          message: "请选择复课时间",
        });
        return;
      }
      if (_t.resumeformIn.end_time_suspen) {
        data.end_time = _t.resumeformIn.end_time_suspen / 1000;
      }
      _t.$refs["suspension"].validate((valid) => {
        if (valid) {
          getcourseUnfreeze(data).then((res) => {
            if (res.error_code == 0) {
              _t.$message({
                type: "success",
                message: "复课成功!",
              });
              _t.resumeclickClose(_t.type);
            } else {
              _t.$message({
                type: "error",
                message: "复课失败!" + res.message,
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    changedateTimes(e) {
      const _t = this;
      if (_t.dateTimes != null) {
        _t.dateTimesBtn = true;
      } else {
        _t.dateTimesBtn = false;
      }
    },
    getfollowadd() {
      const _t = this;
      // 添加跟进
      if (_t.type == "add" || _t.type == "followUp") {
        _t.$refs["form"].validate((valid) => {
          if (valid) {
            if (_t.dateTimes != "") {
              if (_t.dateTimes <= new Date().getTime()) {
                this.$message({
                  type: "warning",
                  message: "跟进时间不能早于当前时间",
                });
                return false;
              }
              _t.searchInfo.pre_follow_time = _t.dateTimes / 1000;
            }
            if (_t.student_id != "") {
              _t.searchInfo.student_id = _t.student_id;
            }
            if (_t.id != "") {
              _t.searchInfo.student_follow_id = _t.id;
            }
            if (_t.fwtextarea != "") {
              _t.searchInfo.content = _t.fwtextarea;
            }
            if (_t.netextarea != "") {
              _t.searchInfo.follow_content = _t.netextarea;
            }
            if (_t.dialogImageUrl.length != 0) {
              _t.searchInfo.images = _t.dialogImageUrl;
            }
            getfollowadd(_t.searchInfo).then((res) => {
              if (res.error_code == 0) {
                _t.$message({
                  type: "success",
                  message: "添加成功",
                });
                _t.$emit("back", _t.type);
              } else {
                _t.$message({
                  type: "error",
                  message: res.message,
                });
                _t.$emit("back", _t.type);
              }
            });
          } else {
            return false;
          }
        });
      }
      if (_t.type == "edit") {
        _t.editform.follow_id = _t.id;
        const data = { ..._t.editform };
        if (data.pre_follow_time != "") {
          if (data.pre_follow_time <= new Date().getTime()) {
            this.$message({
              type: "warning",
              message: "跟进时间不能早于当前时间",
            });
            return false;
          }
          data.pre_follow_time = data.pre_follow_time / 1000;
        } else {
          _t.$message({
            type: "error",
            message: "请选择下次跟进时间",
          });
          return;
        }

        getfollowedit(data).then((res) => {
          if (res.error_code == 0) {
            _t.$message({
              type: "success",
              message: "编辑成功",
            });
            _t.$emit("back", _t.type);
          } else {
            _t.$message({
              type: "error",
              message: res.message,
            });
            _t.$emit("back", _t.type);
          }
        });
      }
      if (_t.type == "close") {
        _t.closeform.follow_id = _t.id;
        getfollowclose(_t.closeform).then((res) => {
          if (res.error_code == 0) {
            _t.$message({
              type: "success",
              message: "取消成功",
            });
            _t.$emit("back", _t.type);
          } else {
            _t.$message({
              type: "error",
              message: res.message,
            });
            _t.$emit("back", _t.type);
          }
        });
      }
    },
    //图片上传
    handlePictureCardPreview(e) {
      this.bigdialogImageUrl = e;
      this.bigdialogVisible = true;
    },
    toOrderDetail(id) {
      this.$router.push({
        name: "orderManageDetail",
        query: {
          id: String(id),
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.followupImg {
  display: flex;
  flex-wrap: wrap;
  .imgbox {
    width: 80px;
    height: 80px;
    margin-right: 20px;
    cursor: pointer;
    position: relative;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .imgboxbig {
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
    display: none;
    position: absolute;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.7);
    i {
      position: relative;
      color: #fff;
      font-size: 20px;
    }
  }
  .imgbox:hover .imgboxbig {
    display: flex;
  }
}
.dialog {
  // 弹框
  /deep/ .el-dialog__header {
    border-bottom: 1px solid #e7e8ea;
  }
  .btnsize {
    margin-left: 10px;
  }
  /deep/.dialogForm {
    display: flex;
    justify-content: space-between;
    .textarea {
      textarea {
        background-color: none;
      }
    }
    .el-form-item {
      margin-right: 12px !important;
    }
  }
  .imageText {
    padding: 10px;
    border: 1px solid #e1e5e9;
    border-radius: 4px;
    /deep/.el-textarea__inner {
      border: 0;
      outline: none;
      padding-left: 0;
    }
    textarea {
      height: 60px;
      width: 100%;
      resize: none;
      border: 0;
      outline: none;
    }
    .order-text {
      padding: 12px 0;
    }
  }
  .black {
    background: #f5f7fa;
  }
  .next_follow {
    display: flex;
    .next_follow_left {
      width: 50%;
      height: 60px;
      display: flex;
      min-width: 320px;
      align-items: center;
      /deep/ .el-input__inner {
        height: 28px;
        line-height: 28px;
        width: 220px;
        font-size: 12px;
      }
      /deep/.el-input__icon {
        line-height: 28px;
      }
    }
    .next_follow_right {
      width: 50%;
      height: 60px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      span {
        color: #ffb940;
      }
    }
  }
  .next_follow_edit {
    margin-bottom: 10px;
  }
  /deep/ .el-upload_img {
    .el-upload {
      width: 80px;
      height: 80px;
      line-height: 95px;
    }
    li {
      height: 80px;
      width: 80px;
    }
  }
  /deep/ .next_follow,
  /deep/ .next_follow_edit {
    .el-input__inner {
      height: 28px;
      line-height: 28px;
      width: 220px;
    }
    .el-input__icon {
      line-height: 28px;
    }
  }
  .operationBox {
    div {
      margin: 0;
      margin-right: 10px;
    }
  }
  .explain {
    font-size: 12px;
    color: #5c5d5e;
    line-height: 18px;
  }
  .explain.color {
    color: #07d1aa;
  }
  .suspensionBox:nth-of-type(1) {
    margin-top: 20px;
  }
  .suspensionBox {
    .el-form-item {
      margin-bottom: 18px !important;
    }
    .el-input {
      width: 220px !important;
    }
  }
  // 弹框end
  //添加学员盒子
  .drawer_box {
    padding: 0 5%;
  }
  .drawer_Head {
    font-size: 14px;
    color: #5c5d5e;
    margin-bottom: 14px;
  }
  .drawer_bottomBtn {
    display: flex;
    justify-content: flex-end;
    max-width: 380px;
    .reloadbtn {
      margin-left: 12px;
    }
  }
  /deep/ .drawer_form {
    padding-top: 20px;
    .drawer_chooseDate {
      background: #fff;
      .inputdate {
        width: 175px;
        .el-input__inner {
          border-radius: 4px 0 0 4px;
        }
      }
      .inputyear {
        width: 85px;
        height: 28px;
        display: inline-block;
        text-align: center;
        border-radius: 0 4px 4px 0px;
        border: 1px solid #dcdfe6;
        vertical-align: middle;
        margin-left: -1px;
        text-align: center;
      }
    }
    .drawer_input {
      width: 260px;
      .el-input-group__prepend {
        background: #fff;
      }
    }
    .drawer_onlychoose {
      .el-input {
        width: 260px;
      }
    }
    .drawer_selectchoose {
      .el-input {
        width: 80px;
      }
      .el-input__inner {
        padding-left: 6px;
      }
    }
  }

  /deep/ .drawerLenan_name {
    .el-form-item__label {
      line-height: 44px !important;
    }
  }
  /deep/ .avatar-uploader {
    .el-upload {
      border: 1px dashed #e7e8ea;
      border-radius: 50%;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 44px;
    height: 44px;
    line-height: 44px;
    text-align: center;
  }
  .avatar {
    width: 44px;
    height: 44px;
    display: block;
  }
  .avatar-preview-wrap {
    position: relative;
    cursor: pointer;
    &:hover .shadow {
      display: block;
    }
    .image {
      border-radius: 50%;
    }
    .shadow {
      position: absolute;
      width: 44px;
      height: 44px;
      top: 0;
      left: 0;
      border-radius: 50%;
      background: rgba($color: #747474, $alpha: 0.7);
      display: none;
      line-height: 44px;
      text-align: center;
      .iconfont {
        color: #fff;
        font-size: 16px !important;
      }
    }
  }
}
.student {
  font-size: 14px;
  font-weight: 600;
}
.student-info {
  display: flex;
  padding: 20px 0px;
  border-bottom: 1px solid #d7d7d7;
  p {
    margin-left: 10px;
    margin-right: 40px;
  }
}
.selfheader {
  margin-left: 5px;
  .question {
    width: 15px;
    height: 15px;
    opacity: 1;
    background: #bebfc0;
    border-radius: 50%;
    color: #fff;
    text-align: center;
    line-height: 16px;
    font-size: 10px;
    margin-left: 5px;
  }
}
/deep/ .el-dialog__body {
  .el-form {
    .el-form-item {
      display: flex;
      .el-form-item__content {
        flex: 1;
        display: flex;
        align-items: center;
      }
    }
  }
  .cancel-form {
    .el-form-item__content {
      margin: 0 !important;
      width: 100%;
      .imageText {
        width: 100%;
      }
    }
  }
}
</style>
